export let draftSenderPersonaPlaceholder = "NXEO";
export default {draftSenderPersonaPlaceholder};